import { useEffect, useState } from 'react';
import Button from '../../common/Button';
import './CredentialForm.scss';

function CredentialForm({ onSubmit, onCancel, isLoading, data, authParams }) {
  const [formData, setFormData] = useState({});

  useEffect(() => {
    setFormData(authParams.reduce((acc, param) => {
      acc[param.name] = data?.credential_data?.[param.name] || '';
      return acc;
    }, {}));
  }, [authParams, data]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit({ credential_data: { ...formData } });
  };

  return (
    <form onSubmit={handleSubmit} className="add-credential-form">
      {authParams.map((param) => {
        return (
          <div key={param.name} className="form-group">
            <label htmlFor={param.name}>{param.label}</label>
            <input
              type={param.type}
              id={param.name}
              name={param.name}
              value={formData[param.name] || ''}
              onChange={handleChange}
              required={param.required}
              disabled={isLoading}
            />
          </div>
        );
      })}

      <div className="form-actions">
        <Button 
          type="button" 
          className="normal cancel-btn" 
          label="Cancel" 
          onClick={onCancel}
          disabled={isLoading}
        />
        <Button 
          type="submit" 
          className="normal submit-btn" 
          label={data.mode}
          isLoading={isLoading}
        />
      </div>
    </form>
  );
}

export default CredentialForm;
